import { motion, useReducedMotion } from "framer-motion";

// The Honest Donkey brand signature — an animated, punchy treatment of the tagline.
export function BrandSignature() {
  const reduce = useReducedMotion();
  return (
    <motion.p
      initial={reduce ? false : { opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 1.4 }}
      className="mt-5 font-heading font-bold text-xl sm:text-2xl leading-snug text-donkey-warm break-words"
      data-testid="hero-tagline"
    >
      Business ideas{" "}
      <span className="relative inline-block">
        <span className="text-gradient-sweep">without the </span>
        <span className="text-gradient-sweep">bullshit.</span>
        {!reduce && <span className="brand-underline" aria-hidden />}
        {!reduce && <span className="brand-lightsweep" aria-hidden />}
      </span>
    </motion.p>
  );
}

export default BrandSignature;
